import React from "react";
import { Stack, Typography } from "@mui/material";
import CustomAvatar from "./CustomAvatar";

interface Props {
  item: any;
  onClick: () => void;
}

function FilterCard({ item, onClick }: Props) {
  return (
    <Stack
      direction="row"
      spacing={2}
      my={2}
      sx={{ cursor: "pointer", borderBottom: "1px solid #B5BAB5" }}
      onClick={onClick}
      alignItems="center"
      pb={1.5}
    >
      <CustomAvatar avatarStyle={{ borderRadius: 100 }} />
      <Typography fontSize={14} fontWeight="600">{`${item.nom} ${item.prenom}`}</Typography>
    </Stack>
  );
}

export default FilterCard;
